export const checkFormIsComplete = (enrollmentEventId, profileProgressMap) =>
  !enrollmentEventId &&
  profileProgressMap.capacityToPay.isComplete &&
  profileProgressMap.capacityToPay.isValid;
